import { SxProps, Theme } from '@mui/material';

export const fieldStyles: SxProps<Theme> = {
    mb: 2,
};

export const agreementBoxStyles: SxProps<Theme> = {
    mt: 1,
    mb: 1,
    p: 2,
    maxHeight: 220,
    overflowY: 'auto',
    border: 1,
    borderColor: 'divider',
    borderRadius: 1,
};

export const agreementTitleStyles: SxProps<Theme> = {
    fontWeight: 600,
    mb: 1,
};

export const agreementParagraphStyles: SxProps<Theme> = {
    fontSize: '0.875rem',
    color: 'text.secondary',
    mb: 1,
};

export const consentStyles: SxProps<Theme> = {
    display: 'block',
    mb: 1,
};

/**
 * The honeypot: out of sight and out of the tab order, but still in the DOM for a bot that
 * fills in every input it finds. Moved off-screen rather than `display: none`, which some bots
 * know to skip.
 */
export const honeypotStyles: SxProps<Theme> = {
    position: 'absolute',
    left: '-10000px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
};

export const submitRowStyles: SxProps<Theme> = {
    mt: 2,
};

export const formAlertStyles: SxProps<Theme> = {
    mb: 2,
};
